import styled, { css } from 'styled-components';
import { CardContainer } from '@anwb/card';
import { NotificationContainer } from '@anwb/notification';
import { pxToRem } from '@anwb/style-utilities';
const GRID_COLUMNS_FACTOR = 8;
export const gridContainerItemStyles = ({ theme, $fullWidth, $inline, $justify, }) => css `
	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		grid-column: span ${GRID_COLUMNS_FACTOR};
		width: 100%;

		${$fullWidth &&
    css `
			grid-column: 1 / -1;
		`}
	}

	${GridContainerItemContent} {
		${$inline &&
    css `
			flex-direction: row;
			@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
				align-items: center;
				gap: ${pxToRem(theme.spacing['400'])};
			}
		`}

		${$justify &&
    css `
			justify-content: ${$justify}};
		`}
	}
`;
export const GridContainerItem = styled.div `
	${gridContainerItemStyles}
`;
/**
 * Grid item content
 */
export const gridContainerItemContentStyles = () => css `
	display: flex;
	flex-direction: column;
	margin: 0;
	padding: 0;

	/* NotificationContainer is added as exception because it should have padding as specified in notification.styled.ts. Preferably, remove this style all together */
	${CardContainer}, & > div:not(${NotificationContainer}) {
		padding: 0;
	}

	.PONCHO-table {
		padding: 0;
	}
`;
export const GridContainerItemContent = styled.div `
	${gridContainerItemContentStyles}
`;
//# sourceMappingURL=gridItem.styled.js.map